import { useEffect } from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import AuthoredPageRoutes from '@/components/authored-page-routes/authored-page-routes';
import { BFF_PATH, PLP_PAGE_TYPE } from '@/data/constants';
import { PreRenderProps } from '@/pages/_app';
import { getPlpViewDefinition } from '@/ssr/view-definition-plp-page-query';
import { ANALYTICS_EVENT_NAMES, collectMetrics, getFullPath, type IApiTiming } from '@iceberg/report-perfect-experience-analytics';
import { fetchDataAndHandleErrors, withTokenRefresh, measureDuration } from '@/utils/ssr-utils';
import { ANALYTICS_PAGE_NAMES, SUCCESS_STATUS_CODE, ERROR_STATUS_CODE } from '@/utils/analytics/constants';
import { getKeyIdFromUrl } from '@/utils';

export const getServerSideProps: GetServerSideProps<PreRenderProps> = withTokenRefresh(async (context: any) => {
  const { result: data, duration: ssrFetchDurationMs } = await measureDuration(() => fetchDataAndHandleErrors(context, getPlpViewDefinition, PLP_PAGE_TYPE.COLLECTION));
  
  const hasBackendFetchData = Boolean(
    data && Object.keys(data).length,
  );
  const { resolvedUrl } = context;
  const keyId = getKeyIdFromUrl(resolvedUrl);
  const ssrFetchData: IApiTiming = {
    name: `POST ${BFF_PATH.COLLECTION}${keyId}`,
    duration: ssrFetchDurationMs,
    status: Number(hasBackendFetchData ? SUCCESS_STATUS_CODE : ERROR_STATUS_CODE),
  };
  return {
    props: {
      ...data,
      ssrFetchData,
    },
  };
});

const CollectionsPlpRoutes = (props: any) => {
  const router = useRouter();
  const slug = router.query.slug;
  const slugString = Array.isArray(slug) ? slug.join('/') : slug || '';
  const pageName = getFullPath();
  collectMetrics(ANALYTICS_EVENT_NAMES.PAGE_INIT, {
    detail: {
      page_name: pageName
    }
  });

  useEffect(() => {
    collectMetrics(ANALYTICS_EVENT_NAMES.PAGE_READY, {
      detail: {
        page_name: pageName,
        page_id: ANALYTICS_PAGE_NAMES.COLLECTIONS,
      }
    }); 
  }, []);
  return <AuthoredPageRoutes key={slugString} pageType={PLP_PAGE_TYPE.COLLECTION} {...props} />;
};

export default CollectionsPlpRoutes;
